import * as Yup from "yup";

export interface AddPartnerFormValues {
    username: string;
}

export const addPartnerValidationSchema = Yup.object<AddPartnerFormValues>({
    username: Yup.string()
        .required("Username is required")
        .min(5, "Username must be at least 12 characters"),
        
});
